import React from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Button from '@material-ui/core/Button';
import {frendlyFormaterSizeInBytes, delay} from '@helpers/functions';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import '@scss/fields.scss';
import {withTranslation} from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    deleteBtn: {
        float: 'right',
    },
}));

function FieldFileDropzoneTable({files, handleRemoveFile, handleDownloadFile, showDeleteBtn = true, t}) {
    const classes = useStyles();
    return (
        <React.Fragment>
            <TableContainer>
                <Table size="small" aria-label="sub table">
                    <TableHead>
                        <TableRow>
                            <TableCell>№</TableCell>
                            <TableCell>{t('photo_edit.file')}</TableCell>
                            <TableCell>{t('photo_edit.size')}</TableCell>
                            {showDeleteBtn ? (
                                <TableCell align="right"/>
                            ) : null}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {files.map((file, index) => {
                            return (
                                <TableRow key={file.id}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>
                                        <Link className="file-link" onClick={() => {
                                            delay(async () => {
                                                await handleDownloadFile(file.id);
                                            }, 200)
                                        }}>
                                            {file.name}
                                        </Link>
                                    </TableCell>
                                    <TableCell>{frendlyFormaterSizeInBytes(file.size)}</TableCell>
                                    {showDeleteBtn ? (
                                        <TableCell>
                                            <Button className={classes.deleteBtn} color="secondary" variant="outlined"
                                                    size="small"
                                                    onClick={() => handleRemoveFile(file.id)}>
                                                {t('delete')}
                                            </Button>
                                        </TableCell>
                                    ) : null}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </React.Fragment>
    );
}

export default withTranslation()(FieldFileDropzoneTable);
